<template>
    <el-dialog v-model="open" width="800">
        <template #header="{ titleId, titleClass }">
            <div class="my-header">
                <h4 :id="titleId" :class="titleClass">卡片选择</h4>
                <el-button size="small" type="primary" style="margin-left: auto;" @click="handleRefresh"
                    :loading="loading">
                    <el-icon>
                        <RefreshRight />
                    </el-icon>
                    刷新
                </el-button>
                <!-- <el-icon style="margin-left: auto;cursor: pointer;" @click="close"><CircleClose /></el-icon> -->
            </div>
        </template>
        <el-scrollbar height="600px">
            <div class="flex_center">
                <el-segmented v-model="selectCardContentType" :options="cardContentTypeList" block @change="handleBigTypeChange">
                    <template #default="{ item }">
                        <div>
                            {{ item.label }}
                        </div>
                    </template>
                </el-segmented>
            </div>
            <div>
                <div v-if="dy_one_click_phone_card_list_ref?.length > 0">
                    <div v-for="item in dy_one_click_phone_card_list_ref" :key="item.reply_id" class="m_card_item">
                        <div class="flex_center">
                            <div style="flex:1;min-width: 0;" class="overflow_ellipsis">
                                <div class=" overflow_ellipsis">
                                    <div class="m_color_2">【{{ item.rule_name }}】</div>
                                    <div>
                                        {{ item.reply_content }}
                                    </div>
                                </div>
                            </div>

                            <div class="send_container" style="width:40%">
                                <el-tooltip class="box-item" effect="light" placement="top-start">
                                    <template #content>
                                        点击发送名片
                                    </template>
                                    <img @click="handleSendCard(item)" src="@assets/img/send.png"
                                        style="width:30px;height: 30px;cursor: pointer;" />
                                </el-tooltip>

                            </div>

                        </div>
                    </div>
                </div>
                <el-empty v-else description="没有数据"></el-empty>
                <!-- {{ chatingPlatId }} - {{ selectedAccountId }}<br />
                {{ dy_one_click_phone_card_list_ref }} -->

            </div>
        </el-scrollbar>

        <!-- {{ cardList }} -->
    </el-dialog>
</template>

<script>
import {
    onMounted,
    ref,
    reactive,
    toRefs,
    watch,
    nextTick,
    inject,
    computed,
    onUnmounted,
} from "vue";
import { useStore } from "vuex";

import { RefreshRight } from "@element-plus/icons-vue";
import { initUserSystemData } from "@/api/userapi";
import { ElMessage } from "element-plus";
import { getAccountConfigInfo } from "@/api/chatapi";
import { getAccountCfg, setAccountCfg, getAccountCfgByKey } from '@/plugins/accountcfgstore'
export default {
    components: { RefreshRight },
    emits: ["sendOneKeyCard"],
    props: { _item: { type: String, default: '' } },
    setup(props, { emit }) {
        // ---------- 属性 --------------------
        let store = useStore();
        const open = ref(false)
        const dy_one_click_phone_card_list_ref = ref([])
        const loading = ref(false)
        const bus = inject("$eventBus");
        const eventbusCms = inject("eventbusCms");

        //todo 以后多平台需要修改扩展
        //选择的卡片类型
        const selectCardContentType = ref('dy_one_click')
        //卡片类型
        const cardContentTypeList = ref([
            { label: "抖音一键留资", value: "dy_one_click" },
        ])
        //当前选中平台
        const chatingPlatId = computed(() => {
            return store.state.chat_store.chat_plat_id
        });
        //当前选中账号
        const selectedAccountId = computed(() => {
            return store.state.chat_store.user_account_select?.id
        });



        // ---------- 方法 --------------------

        const handleRefresh = async () => {
            let data = { aid: selectedAccountId.value }
            loading.value = true
            //远程请求数据
            getAccountConfigInfo(data)
        }

        const show = () => {
            open.value = true
            let aid = selectedAccountId.value
            let dy_one_click_phone_card_list = getAccountCfgByKey(aid, 'dy_one_click_phone_card_list')
            if (!dy_one_click_phone_card_list) {
                dy_one_click_phone_card_list_ref.value = []
                handleRefresh()
            } else {
                dy_one_click_phone_card_list_ref.value = dy_one_click_phone_card_list
            }
        }

        const handleAccountCfgChange = async () => {
            loading.value = false
            let aid = selectedAccountId.value
            let dy_one_click_phone_card_list = getAccountCfgByKey(aid, 'dy_one_click_phone_card_list')
            dy_one_click_phone_card_list_ref.value = dy_one_click_phone_card_list || []
        }

        const handleSendCard = async (cardItem) => {
            emit('sendOneKeyCard', {content_type:selectCardContentType.value,...cardItem})
            open.value = false
        }

        const handleBigTypeChange = async () => {

        }

        onMounted(() => {
            bus.on(eventbusCms.accontConfigChange, handleAccountCfgChange)
        })

        onUnmounted(() => {
            bus.off(eventbusCms.accontConfigChange)
        })


        // ---------- 生命周期 --------------------
        return {
            open,
            store,
            dy_one_click_phone_card_list_ref,
            chatingPlatId,
            selectedAccountId,
            loading,
            selectCardContentType,
            cardContentTypeList,
            // ----- 图标 -------
            // --------- 方法 ------
            show,
            handleSendCard,
            handleRefresh,
            handleBigTypeChange,
        }
    }


}



</script>

<style lang="scss" scoped>
.my-header {
    display: flex;
    align-items: center;

}

.m_card_item {
    padding-top: 10px;
    padding-bottom: 5px;
}

.m_card_item:not(:first-child) {
    border-top: 1px dashed #d9d9d9;

}

.send_container {
    align-self: flex-start;
    position: relative;
    transform: translateY(25%);
    cursor: pointer;
}
</style>